import React, { createContext, useContext } from 'react'
//import { useLocalStorage } from '@uidotdev/usehooks' //FIXME: https://github.com/uidotdev/usehooks/issues/264
import { useGetKVCodeSet } from '../../../APIs/Hooks/CodeSetHooks'
import {
  tsCodeSetValue,
  tsGetScreensByHolding,
} from '../../../Typescript/API_Response'
import { AxiosResponse } from 'axios'
import { UseQueryResult } from 'react-query'
import { drawer } from '../../../garvan-react/Constants/StyleConstants'
import DrawerConfig from '../../../DrawerMenus/DrawerConfig'
import { Box } from '@mui/material'
import { useHealthMenuItems } from '../../../DrawerMenus/MenuItems/HealthMenu'
import { useStuartGet } from '../../../APIs/Hooks/PhpAPIHooks'
import { useHoldingContext } from '../../CurrentHolding'
import { usePyGet } from '../../../APIs/Hooks/PyAPIHooks'

interface HealthContextType {
  lineQuery: UseQueryResult<tsCodeSetValue[], AxiosResponse<any, any>>
  screenFacilityQuery: UseQueryResult<tsCodeSetValue[], AxiosResponse<any, any>>
  facilityQuery: UseQueryResult<tsCodeSetValue[], AxiosResponse<any, any>>
  screensQuery: UseQueryResult<tsGetScreensByHolding, AxiosResponse<any, any>>
  mhsTests: UseQueryResult<string[], AxiosResponse<any, any>>
}

export const HealthContext = createContext<HealthContextType>(
  {} as HealthContextType,
)
export const useHealthContext = () => useContext(HealthContext)

function HealthModule({ children }: { children: any }) {
  const { currentHolding } = useHoldingContext()
  const lineQuery = useGetKVCodeSet('KV-ActiveLines')
  const screenFacilityQuery = useGetKVCodeSet('KV-ScreenFacilities')
  const facilityQuery = useGetKVCodeSet('KV-Facilities')
  const mhsTests = usePyGet(['/mhs/tests'])
  const screensQuery = useStuartGet([
    '/screen/getScreensForHolding.php',
    `?HoldingID=${currentHolding.value}`,
  ])
  const menuItems = useHealthMenuItems(screensQuery)
  return (
    <Box
      sx={{
        width: 1,
        pl: drawer / 10,
        pr: { xl: drawer / 10 }, //center if enough space
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <DrawerConfig
        itemsInit={menuItems.filter((m) => m?.permission !== false)}
      />
      <HealthContext.Provider
        value={{
          lineQuery,
          screenFacilityQuery,
          facilityQuery,
          screensQuery,
          mhsTests,
        }}
      >
        {children}
      </HealthContext.Provider>
    </Box>
  )
}

export default HealthModule
